import { FC } from "react";
import { useForecastContext } from "../../../../../context/forecastContext";
import SkeletonLoader from "../../../../SkeletonLoader";
import ErrorMessage from "../../../../errorMessage/errorMessage";
import dayjs from "dayjs";
import { findWeatherForecatForDate } from "../../../../../utilities/weatherHelpers";
import { Popover } from "@tag/tag-components-react-v4";
import DynamicSvgLoader from "../../../../dynamicSvgLoader";
import { useTheme } from "../../../../../context/themeContext";
import "./monthDayWeather.css";
import { useWeatherQuery } from "../../../../../services/weatherService";

type MonthDayWeatherProps = {
  day: dayjs.Dayjs;
};

const MonthDayWeather: FC<MonthDayWeatherProps> = ({ day }) => {
  const { forecastState } = useForecastContext();
  const { theme } = useTheme();
  const {
    data: weather,
    isLoading,
    isError,
  } = useWeatherQuery({
    location: forecastState.selectedSite?.postCode!,
    searchPeriod: forecastState.searchPeriod,
  });

  if (isLoading) {
    return <SkeletonLoader />;
  }

  if (isError) {
    return <ErrorMessage dataType="Weather" fontSize="11px" />;
  }
  const weatherForecast = findWeatherForecatForDate(day, weather ?? []);

  // to-do show a no data message
  if (!weatherForecast) {
    return <SkeletonLoader />;
  }
  return (
    <div className="month-day-weather-statistics">
      <Popover
        popoverFor={
          <div className="month-day-weather-icon">
            <DynamicSvgLoader iconName={weatherForecast.icon} />
          </div>
        }
        background={theme}
        style={{
          borderRadius: "8px",
          border: "1px solid var(--border-color)",
        }}
      >
        <div className="month-day-weather-popover-content">
          {weatherForecast.description
            ? weatherForecast.description
            : weatherForecast.conditions}
        </div>
      </Popover>
    </div>
  );
};

export default MonthDayWeather;
